/**
 * PageTitle — sets the document <title> for an authenticated route.
 *
 * Renders through react-helmet-async, so the title updates correctly on
 * client-side navigation and is announced by screen readers. Deeper instances
 * win, so a detail page can override its layout's generic title:
 *
 *   <PageTitle title={client?.name || "Client"} />
 */
import { Helmet } from "react-helmet-async";
import { formatTitle } from "@/lib/pageTitles";

export default function PageTitle({ title, admin = false }) {
  return (
    <Helmet>
      <title>{formatTitle(title, { admin })}</title>
    </Helmet>
  );
}
